import { CountryCode } from '../../types/lang/language';

type FormatOptions = {
  time: string;
  dateTime: string;
  shortDate: string;
  dayMonthTime: string;
  fullDateTime: string;
};

export const formatOptions = (code: CountryCode | undefined): FormatOptions => {
  const configuration = {
    GB: {
      time: 'HH:mm',
      shortDate: 'dd MMM yyyy',
      dayMonthTime: 'dd MMM HH:mm',
      dateTime: 'dd MMM yyyy HH:mm',
      fullDateTime: 'eeee, dd MMMM yyyy HH:mm',
    } as FormatOptions,
    US: {
      time: 'h:mm aaa',
      shortDate: 'MMM dd yyyy',
      dayMonthTime: 'dd MMM h:mm aaa',
      dateTime: 'dd MMM yyyy h:mm aaa',
      fullDateTime: 'eeee, dd MMMM yyyy h:mm aaa',
    } as FormatOptions,
  }[code ?? 'GB'];

  return configuration;
};
